/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BuilderNavigationService, CommonActions, CommonFlowState, ListActionPipelines } from '@gh/builder-shared';
import { BuilderPermissionSet } from '@gh/builder-shared-data';
import { AppRouter, getRouteInitData, UserContext } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { GridDefinitionFactory, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { mapTo$ } from '@gh/rx/operators';
import { without } from 'lodash';
import { AccountingDrawRuleListTabBusinessService } from '../../resources/accounting-draw-rule-list-tab-business.service';
import { DrawRuleListItem } from '../../resources/accounting-draw-rule.model';

@Component({
  selector: 'gh-accounting-draw-rule-list',
  template: require('./accounting-draw-rule-list-tab.component.html'),
})
export class AccountingDrawRuleListTabComponent implements OnInit {
  drawRules: DrawRuleListItem[];
  gridDefinition: LayoutBasedGridDefinition;

  constructor(private route: ActivatedRoute,
              private userContext: UserContext,
              private router: AppRouter,
              private gridDefinitionFactory: GridDefinitionFactory,
              private business: AccountingDrawRuleListTabBusinessService,
              private pipelines: ListActionPipelines,
              private commonActions: CommonActions,
              private navigations: BuilderNavigationService) {
  }

  ngOnInit(): void {
    const { gridLayout, drawRules } = getRouteInitData(this.route);

    this.gridDefinition = this.gridDefinitionFactory.buildLayoutBased({});
    this.gridDefinition.bind(gridLayout);

    this.drawRules = drawRules;
  }

  onCreate(): void {
    this.router.navigateToChild(['/setup/accounting/draw-rules/new']);
  }

  onOpen(drawRule: DrawRuleListItem): void {
    if (this.userContext.hasPermission(BuilderPermissionSet.Setup.Accounting.DrawRules.EDIT_VIEW)) {
      this.router.navigateToChild(['/setup/accounting/draw-rules', drawRule.id]);
    }
  }

  onClone(drawRule: DrawRuleListItem): void {
    this.router.navigateToChild(['/setup/accounting/draw-rules/new'], { queryParams: { cloneFrom: drawRule.id } });
  }

  onDelete(drawRule: DrawRuleListItem): void {
    const flow = this.pipelines.toggleItem<CommonFlowState<DrawRuleListItem>>({
      question: { id: 'msg_rule_delete', params: { code: drawRule.code } },
      validate: this.commonActions.validate(({ value }) => this.business.checkUsage(value)),
      execute: this.commonActions.execute(({ value }) =>
        this.business.remove(value).pipe(mapTo$(value))),
      finish: () => this.drawRules = without(this.drawRules, drawRule),
    });

    flow.run({ value: drawRule });
  }

  goToAel(entityId?: ID): void {
    this.navigations.goToAel({
      entityType: 'DRAW_RULE',
      entityId,
      label: 'lbl_draw_rules',
    });
  }
}
